/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severitypayment1Inputs */

const en_severitypayment1 = /** @type {(inputs: Severitypayment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const pt_severitypayment1 = /** @type {(inputs: Severitypayment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Severitypayment1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severitypayment1 = /** @type {((inputs?: Severitypayment1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severitypayment1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severitypayment1(inputs)
	return pt_severitypayment1(inputs)
});
export { severitypayment1 as "severityPayment" }